
























































































































import { Component, Vue } from 'vue-property-decorator';
import { yunnanDataViewServer } from '@/api/installServer';
import PatrolDialog from '../../yunnanDataView/unit/box5/box-5-unit-2.vue';
import DangerDialog from '../../yunnanDataView/unit/box5/box-5-unit-5.vue';

@Component({
  components: { PatrolDialog, DangerDialog },
})
export default class DataBox1 extends Vue {
  private $echarts: any;
  private dataForm: any = {
    block1: {},
    block4: {},
  };
  private shouldPatrolNum: any = '-';
  private unPatrolNum: any = '-';

  private patrolRate: any = '';

  private searchForm: any = {};

  mounted() {
    // this.getData({});
  }

  getData(opts: any) {
    this.searchForm = opts;
    this.getData1(opts);
    this.getData2(opts);
  }
  private getData1(opts: any) {
    yunnanDataViewServer
      .getHazard({ deptId: opts.deptId || null })
      .then((res: any) => {
        this.dataForm = res.data;
        this.dataForm.block1.rectifyHazardRate = this.dataForm.block1.rectifyHazardRate === '/' ? 0 : Number(this.dataForm.block1.rectifyHazardRate);
        this.dataForm.block1.timelyRectifyHazardRate = this.dataForm.block1.timelyRectifyHazardRate === '/' ? 0 : Number(this.dataForm.block1.timelyRectifyHazardRate);
        this.showCharts();
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  private getData2(opts: any) {
    const form: any = {
      dateRangeType: 'CURRENT_DAY',
      topDeptId: opts.deptId,
    };
    yunnanDataViewServer
      .getPatrolAndDeviceStatistics(form)
      .then((res: any) => {
        this.shouldPatrolNum = res.data.total.shouldPatrolNum;
        this.unPatrolNum = res.data.total.unPatrolNum;
        this.patrolRate = res.data.total.shouldPatrolNum > 0 ? ((res.data.total.alreadyPatrolNum / res.data.total.shouldPatrolNum) * 100).toFixed(2) : '-';
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  patrolList(type: any) {
    let finishFlag: any;
    if (type === 'unPatrolNum') {
      finishFlag = false;
    }

    const ref: any = this.$refs['patrolDialogRef'];
    ref.showDialog(
      {
        topDeptId: this.searchForm.deptId,
      },
      finishFlag,
    );
  }

  dangerList(type: any, finishFlag: any) {
    const ref: any = this.$refs['dangerDialogRef'];
    const data: any = {
      finishFlag: finishFlag,
      hazardLevel: type,
      handleDepartmentId: this.searchForm.deptId,
    };
    ref.showDialog(data, finishFlag);
  }

  private showCharts() {
    const nameArr: any = [];
    const valueArr1: any = [];
    const valueArr2: any = [];
    const valueArr3: any = [];
    const valueArr4: any = [];
    this.dataForm.block4.forEach((item: any) => {
      nameArr.push(item.month + '月');
      valueArr1.push(item.activelyDiscoverHazardTotal); // 主动发现
      valueArr2.push(item.checkDiscoverHazardTotal); // 检查发现
      valueArr3.push(item.rectifyHazardTotal); // 整改数

      valueArr4.push(item.rectifyRate === '/' ? 0 : item.rectifyRate); // 整改率
    });
    const echartsA = this.$echarts.init(document.getElementById('house-charts-5-1') as any);
    const optionA = {
      title: {
        text: '',
        subtext: '',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['主动发现', '检查发现', '整改数', '整改率'],
        x: 'right',
        y: 'top',
        textStyle: {
          fontSize: 10, //字体大小
          color: '#999', //字体颜色
        },
        itemWidth: 10, // 设置宽度
        itemHeight: 10, // 设置高度
        itemGap: 10, // 设置间距
      },
      grid: {
        left: '4%',
        right: '4%',
        bottom: '20%',
        top: '18%',
        containLabel: true,
      },
      yAxis: [
        {
          type: 'value',
          minInterval: 1,
          axisLabel: {
            textStyle: {
              color: '#888',
              fontSize: 11,
            },
          },
          splitLine: {
            lineStyle: {
              color: '#ccc',
              type: 'dashed',
            },
          },
          boundaryGap: [0, 0.01],
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
        },
        {
          type: 'value',
          max: 100,
          axisLabel: {
            textStyle: {
              fontSize: 11,
              color: '#888',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed',
            },
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          boundaryGap: [0, 0.01],
        },
      ],
      xAxis: {
        triggerEvent: true,
        data: nameArr,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: '#888',
            fontSize: 10,
          },
        },
      },
      dataZoom: [
        {
          type: 'slider',
          id: 'heng',
          xAxisIndex: [0],
          filterMode: 'none', // 当前数据窗口外的数据，被 过滤掉。即 会 影响其他轴的数据范围。每个数据项，只要有一个维度在数据窗口外，整个数据项就会被过滤掉。
          start: 0, // 显示0% 开始的数据， 到 10%的数据结束，相当展示前10%的数据，做到降采样
          end: 100,
          bottom: '12%',
          left: '6%',
          right: '6%',
          height: 4,
          handleSize: '400%',
          handleStyle: {
            color: '#73a0fa',
          },
          borderColor: 'transparent',
          backgroundColor: 'rgba(0,0,0,0.04)',
          dataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          fillerColor: '#73a0fa',
          textStyle: {
            color: 'transparent',
          },
        },
      ],
      series: [
        {
          name: '主动发现',
          type: 'bar',
          stack: 'total',
          barWidth: 8,
          data: valueArr1,
          color: '#0091FF',
          itemStyle: {
            normal: {
              barBorderRadius: 2,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '检查发现',
          type: 'bar',
          // smooth: true,
          stack: 'total',
          barWidth: 8,
          data: valueArr2,
          color: '#FF6262',
          itemStyle: {
            normal: {
              barBorderRadius: 2,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '整改数',
          type: 'bar',
          barWidth: 8,
          data: valueArr3,
          color: '#13BCFF',
          itemStyle: {
            normal: {
              barBorderRadius: 2,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '整改率',
          type: 'line',
          yAxisIndex: 1,
          barWidth: 8,
          data: valueArr4,
          color: '#13BCFF',
          itemStyle: {
            normal: {
              barBorderRadius: [2, 2, 2, 2],
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
      ],
    };

    echartsA.setOption(optionA);
  }
}
